import React from 'react';
import { BookOpen, Menu } from 'lucide-react';
import { scrollToPricing } from './utils';
export function TopBar() {
  return <nav className="bg-[#0f172a] text-white py-3 px-5 flex items-center justify-between sticky top-0 z-40 border-b border-white/5" data-id="element-228">
      <div className="flex items-center gap-2.5" data-id="element-229">
        <div className="w-8 h-8 bg-[#d4a017]/20 rounded-lg flex items-center justify-center" data-id="element-230">
          <BookOpen size={18} className="text-[#d4a017]" data-id="element-231" />
        </div>
        <span className="font-bold text-sm tracking-tight" data-id="element-232">SIC 360</span>
      </div>
      <button onClick={scrollToPricing} className="bg-[#d4a017] hover:bg-[#b88a14] text-[#0f172a] font-bold text-xs px-4 py-2 rounded-lg transition-colors hidden sm:block" data-id="element-233">
        Quiero acceso
      </button>
      <button className="sm:hidden text-white/70 hover:text-white transition-colors" onClick={scrollToPricing} data-id="element-234">
        <Menu size={24} data-id="element-235" />
      </button>
    </nav>;
}